import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createRegistration = (payload) =>
  api.post("/registrations", payload).then((r) => r.data);

export const createPaymentOrderUSD = (payload) =>
  api.post("/payment/create-order-usd", payload).then((r) => r.data);

export const verifyPaymentUSD = (payload) =>
  api.post("/payment/verify-usd", payload).then((r) => r.data);

export const createContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

export const createInterest = (payload) =>
  api.post("/interest", payload).then((r) => r.data);

export const listInterest = (token) =>
  api.get("/admin/interest-list", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const getEmailStatus = (token, recheck = false) =>
  api
    .get("/admin/email-status", { params: { recheck }, headers: { "X-Admin-Token": token } })
    .then((r) => r.data);

export const sendLondonLaunch = (token) =>
  api
    .post("/admin/interest-list/send-launch", null, { headers: { "X-Admin-Token": token } })
    .then((r) => r.data);

export const adminLogin = (token) =>
  api.post("/admin/login", { token }).then((r) => r.data);

export const listRegistrations = (token) =>
  api
    .get("/admin/registrations", { headers: { "X-Admin-Token": token } })
    .then((r) => r.data);

export const listContactMessages = (token) =>
  api
    .get("/admin/contact-messages", { headers: { "X-Admin-Token": token } })
    .then((r) => r.data);

export const getAdminStats = (token) =>
  api
    .get("/admin/stats", { headers: { "X-Admin-Token": token } })
    .then((r) => r.data);
